var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import { Icons } from 'src/ui/components/Icons/Icons';
import { E_TOOLTIP_POSITION, Tooltip } from 'src/ui/components/ToolTip/Tooltip';
import { E_ICONS } from 'src/ui/components/Icons/constants';
import { COLORS } from 'src/shared/styles/colors';
import styles from './inputWrapperFilter.module.scss';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var InputWrapperFilter = function (props) {
    var i18n = props.i18n, children = props.children, className = props.className, onDelete = props.onDelete;
    var deleteTooltip = getPropsByKeyPath(i18n.components, 'tooltips.cases.deleteFilter');
    return (_jsxs("div", __assign({ className: classNames(styles.inputWrapperFilterWrapper, className) }, { children: [onDelete && (_jsxs("span", __assign({ className: styles.inputWrapperFilterIcon }, { children: [_jsx(Tooltip, __assign({ position: E_TOOLTIP_POSITION.LEFT, className: styles.deleteToolTip }, { children: deleteTooltip })), _jsx(Icons, { icon: E_ICONS.CLOSE, onClick: onDelete, color: COLORS.RED['500'] })] }))), children] })));
};
